import Login from '@components/pages/login';

export default Login;
